import { createRoot, useEffect, useState } from "@wordpress/element"
import useFeaturedPosts from "./hooks/useFeaturedPosts"
import "./style.scss"

const App = () => {
    const categoryMap = {

        platform_posts: "Platform",
        thought_leadership_posts: "Thought Leadership",
        customer_stories_posts: "Customer Stories",
    }

    const [categoryToShow, setCategoryToShow] = useState(null)

    const updateCategory = () => {
        let selectedCategory
        if (typeof FWP !== "undefined" && FWP.facets["resources"]) {
            const selected = FWP.facets["resources"]
            if (selected.length > 0) {
                const selectedKey =
                    selected[0].toLowerCase().replace(/-/g, "_") + "_posts"
                selectedCategory = Object.keys(categoryMap).includes(selectedKey)
                    ? selectedKey
                    : null
            }
        }
        setCategoryToShow(selectedCategory)
    }

    useEffect(() => {
        document.addEventListener("facetwp-loaded", updateCategory)
        return () => (
            document.removeEventListener("facetwp-loaded", updateCategory)
        )
    }, [])

    return (
        <>
            {/* Show the category */}
            <h1 class="blog-header h5 cell alignleft">Conviva Blog{categoryToShow ? ':' : ''} {categoryMap[categoryToShow] || ""}</h1>
            <FeaturedPosts
                categoryToShow={categoryToShow}
                categoryMap={categoryMap}
            />
        </>
    )
}

const FeaturedPosts = ({ categoryToShow, categoryMap }) => {
    const { featuredPosts, loading, error } = useFeaturedPosts()
    if (loading)
        return (
            <>
                <p className="facetwp-loading">
                    <svg
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 288 288"
                    >
                        <path class="cls-1" d="M0 0h288v288H0z" />
                        <path
                            class="cls-2"
                            d="M167 122.89a4.48 4.48 0 0 1 1.64-6.13l22.67-13.09a2.37 2.37 0 0 0 0-4.1l-44.94-25.96a4.72 4.72 0 0 0-4.74 0l-44.95 26a2.37 2.37 0 0 0 0 4.1l22.67 13.09a4.48 4.48 0 0 1 1.64 6.13 4.49 4.49 0 0 1-6.13 1.64l-32.59-18.85a4.74 4.74 0 0 1 0-8.21l59.36-34.27a4.72 4.72 0 0 1 4.74 0l59.36 34.27a4.74 4.74 0 0 1 0 8.21l-32.59 18.81a4.49 4.49 0 0 1-6.14-1.64z"
                        />
                        <path
                            class="cls-3"
                            d="M192.17 169.17L151 145.4a4.74 4.74 0 0 1-2.36-4.1V93.75a4.73 4.73 0 0 1 7.1-4.1l15.05 8.69a4.48 4.48 0 0 1 1.64 6.13 4.49 4.49 0 0 1-6.13 1.65l-5.13-3a2.36 2.36 0 0 0-3.55 2v30.9a4.72 4.72 0 0 0 2.37 4.1l30.31 17.51v-10a4.49 4.49 0 0 1 4.49-4.49 4.49 4.49 0 0 1 4.49 4.49v17.38a4.73 4.73 0 0 1-7.11 4.16z"
                        />
                        <path
                            class="cls-2"
                            d="M148.63 220.65V183a4.49 4.49 0 0 1 4.49-4.49 4.49 4.49 0 0 1 4.49 4.49v26.2a2.37 2.37 0 0 0 3.56 2.05l44.94-25.95a4.73 4.73 0 0 0 2.37-4.1v-51.91a2.37 2.37 0 0 0-3.55-2l-22.66 13.09a4.5 4.5 0 0 1-6.14-1.65 4.49 4.49 0 0 1 1.64-6.13l32.59-18.82a4.74 4.74 0 0 1 7.11 4.11v68.54a4.77 4.77 0 0 1-2.37 4.11l-59.36 34.27a4.74 4.74 0 0 1-7.11-4.16z"
                        />
                        <path
                            class="cls-3"
                            d="M88.73 165.07v-17.38a4.49 4.49 0 0 1 4.49-4.49 4.49 4.49 0 0 1 4.49 4.49v10L128 140.21a4.72 4.72 0 0 0 2.37-4.1v-30.9a2.36 2.36 0 0 0-3.55-2l-5.13 3a4.49 4.49 0 0 1-6.13-1.65 4.48 4.48 0 0 1 1.64-6.13l15.05-8.69a4.73 4.73 0 0 1 7.1 4.1v47.46a4.74 4.74 0 0 1-2.36 4.1l-41.16 23.77a4.73 4.73 0 0 1-7.1-4.1z"
                        />
                        <path
                            class="cls-2"
                            d="M132.26 224.76L72.9 190.49a4.77 4.77 0 0 1-2.37-4.11v-68.54a4.74 4.74 0 0 1 7.11-4.11l32.59 18.82a4.49 4.49 0 0 1 1.64 6.13 4.5 4.5 0 0 1-6.14 1.65l-22.66-13.09a2.37 2.37 0 0 0-3.55 2v51.96a4.73 4.73 0 0 0 2.37 4.1l44.94 25.95a2.37 2.37 0 0 0 3.56-2.05V183a4.49 4.49 0 0 1 4.49-4.49 4.49 4.49 0 0 1 4.49 4.49v37.62a4.74 4.74 0 0 1-7.11 4.14z"
                        />
                        <path
                            class="cls-3"
                            d="M166.36 192.43a4.49 4.49 0 0 1 1.64-6.13l5.13-3a2.37 2.37 0 0 0 0-4.11l-26.76-15.45a4.77 4.77 0 0 0-4.74 0l-26.76 15.45a2.37 2.37 0 0 0 0 4.11l5.13 3a4.49 4.49 0 0 1 1.64 6.13 4.5 4.5 0 0 1-6.14 1.65l-15-8.69a4.74 4.74 0 0 1 0-8.21l41.17-23.77a4.72 4.72 0 0 1 4.74 0l41.17 23.77a4.74 4.74 0 0 1 0 8.21l-15 8.69a4.5 4.5 0 0 1-6.22-1.65z"
                        />
                    </svg>
                </p>
                {console.log("Loading...")}
            </>
        )
    if (error) return <p>Error: {error}</p>

    // Helper function to calculate grid classes
    const getCellClass = (posts, index) => {
        if (posts.length === 1) return "medium-12"
        if (posts.length === 2) return "medium-6"
        if (posts.length === 3) return index === 0 ? "medium-12" : "medium-6"
        return "medium-12" // Default
    }

    // If no category selected, display the first post from each category
    if (!categoryToShow) {
        const postsToShow = Object.keys(featuredPosts)
            .map((categoryKey) => featuredPosts[categoryKey]?.[0])
            .filter(Boolean)

        return (
            <>
                {postsToShow.map((post, index) => {
                    const cellClass = getCellClass(postsToShow, index)

                    const categoryKey = Object.keys(featuredPosts).find((categoryKey) => {
                        return featuredPosts[categoryKey].some((p) => p.ID === post.ID)
                    })

                    return (
                        <div
                            key={post.ID}
                            className={`cell ${cellClass}`}
                        >
                            <article id={`post-${post.ID}`} role="article">
                                <a className="card-link" href={post.link} target="_self" rel="noopener noreferrer">
                                    <section className="featured-image post-card" itemprop="text">
                                        <header className="article-header">
                                            {post.featured_image ? (
                                                <img src={post.featured_image} alt={post.title} />
                                            ) : (
                                                <img src='./../assets/images/general-resources.png' alt={post.title} />
                                            )}
                                            <h2 className="featured-header gradient-text-2">{categoryMap[categoryKey]}</h2>
                                        </header>
                                    </section>
                                    <section className="entry-content" itemprop="text">
                                        {post.title && (
                                            <h3 dangerouslySetInnerHTML={{ __html: post.title }} />
                                        )}
                                        {post.excerpt ? (
                                            <p className="excerpt post-text" dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                                        ) : (<a className="card-link-fallback" href={post.link} target="_self" rel="noopener noreferrer">
                                            Read More
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_6385_7525)">
                                                    <path
                                                        d="M3.125 10H16.875"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M11.25 4.375L16.875 10L11.25 15.625"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6385_7525">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>)}
                                        <a className="read-more" href={post.link} target="_self" rel="noopener noreferrer">
                                            Read More
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_6385_7525)">
                                                    <path
                                                        d="M3.125 10H16.875"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M11.25 4.375L16.875 10L11.25 15.625"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6385_7525">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    </section>
                                </a>
                            </article>
                        </div>
                    )
                })}
            </>
        )
    }

    // If a category is selected, display posts from the selected category
    const posts = featuredPosts[categoryToShow]

    if (!posts || posts.length === 0) {
        return <p>No featured posts available.</p>
    }

    return (
        <>
            {posts.map((post, index) => {
                const cellClass = getCellClass(posts, index)

                return (
                    <div
                        key={post.ID}
                        className={`cell ${cellClass}`}
                    >
                        <article id={`post-${post.ID}`} role="article">
                            <a className="card-link" href={post.link} target="_self" rel="noopener noreferrer">
                                <section className="featured-image post-card" itemprop="text">
                                    <header className="article-header">
                                        {post.featured_image ? (
                                            <img src={post.featured_image} alt={post.title} />
                                        ) : (
                                            <img src='./../assets/images/general-resources.png' alt={post.title} />
                                        )}
                                        <h2 className="featured-header gradient-text-2">
                                            Featured Content
                                        </h2>
                                    </header>
                                </section>
                                <section className="entry-content" itemprop="text">
                                    {post.title && (
                                        <h3 dangerouslySetInnerHTML={{ __html: post.title }} />
                                    )}
                                    {post.excerpt ? (
                                        <p className="excerpt post-text" dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                                    ) : (
                                        <a className="card-link-fallback" href={post.link} target="_self" rel="noopener noreferrer">
                                            Read More
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_6385_7525)">
                                                    <path
                                                        d="M3.125 10H16.875"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M11.25 4.375L16.875 10L11.25 15.625"
                                                        stroke="#1F2D3B"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6385_7525">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    )}
                                    <a className="read-more" href={post.link} target="_self" rel="noopener noreferrer">
                                        Read More
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_6385_7525)">
                                                <path
                                                    d="M3.125 10H16.875"
                                                    stroke="#1F2D3B"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M11.25 4.375L16.875 10L11.25 15.625"
                                                    stroke="#1F2D3B"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_6385_7525">
                                                    <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </section>
                            </a>
                        </article>
                    </div>
                )
            })}
        </>
    )
}

const appRoot = document.getElementById("featured-posts-container")
if (appRoot) {
    const root = createRoot(appRoot)
    root.render(<App />)
}
